var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-profile",class:{'open': _vm.showProfile},on:{"click":function($event){$event.preventDefault();return _vm.toggle.apply(null, arguments)}}},[_c('div',{staticClass:"toggle-profile__text"},[_vm._v(_vm._s(_vm.$t('why_are_we_recommending_this_fragrances')))]),_c('div',{staticClass:"toggle-profile__icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }